// extracted by mini-css-extract-plugin
export var canvas = "_b-1";
export var container = "_b-0";
export var fallback = "_b-2";